import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { cn, formatTime } from '@/lib/utils';
import { CheckCircle2, XCircle } from 'lucide-react';
import { t } from '@/i18n';

// Validated rows; rows with errors are shown but not imported.
export const ImportPreview = ({ rows, onImport }) => {
  const ok = rows.filter(r => !r.errors.length);
  const failed = rows.length - ok.length;

  return (
    <Card className="p-0 overflow-hidden">
      <div className="flex flex-wrap items-center gap-2 p-4 border-b">
        <div className="text-sm font-semibold mr-auto">{t('import.preview.title')}</div>
        <Badge variant="outline" className="bg-emerald-50 text-emerald-700 border-emerald-200">{t('import.preview.ok')}: {ok.length}</Badge>
        {failed > 0 && <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">{t('import.preview.failed')}: {failed}</Badge>}
        <Button size="sm" disabled={!ok.length} onClick={() => onImport(ok)}>
          {t('import.preview.import')} ({ok.length})
        </Button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-xs text-muted-foreground">
            <tr>
              <th className="px-3 py-2" />
              <th className="text-left font-medium px-3 py-2 whitespace-nowrap">{t('import.field.orderId')}</th>
              <th className="text-left font-medium px-3 py-2">{t('import.preview.problems')}</th>
              {['carrier', 'time', 'material', 'customer'].map(f => (
                <th key={f} className="text-left font-medium px-3 py-2 whitespace-nowrap">{t(`import.field.${f}`)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.index} className={cn('border-t', r.errors.length && 'bg-red-50/60')}>
                <td className="px-3 py-2">
                  {r.errors.length ? <XCircle className="h-4 w-4 text-red-600" /> : <CheckCircle2 className="h-4 w-4 text-emerald-600" />}
                </td>
                <td className="px-3 py-2 whitespace-nowrap font-medium">{r.orderId || '—'}</td>
                <td className="px-3 py-2 text-xs text-red-700 min-w-[140px]">
                  {[...r.errors, ...r.warnings].map(p => t(`import.problem.${p}`)).join(', ')}
                </td>
                <td className="px-3 py-2 whitespace-nowrap">{r.carrier?.name || r.carrierRaw || '—'}</td>
                <td className="px-3 py-2 whitespace-nowrap tabular-nums">{r.plannedAt ? formatTime(r.plannedAt) : '—'}</td>
                <td className="px-3 py-2 whitespace-nowrap">{r.material || '—'}</td>
                <td className="px-3 py-2 whitespace-nowrap">{r.customer || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
